import { Alert } from "@mui/material";
import { patientFormTexts } from "../patient-form-texts";
import { AddressGroupShadcn } from "../../../form-input-components/groups/address.group";
import { usePatientForm } from "./PatientFormContext";
import { useCentralStore } from "@/dentlab/src/store/Central";
import { CustomSelectShadcn } from "@/dentlab/src/components/custom-select-shadcn.component";
import { CustomTextFieldShadcn } from "../../../form-input-components/custom-input-components/custom-text-field-shadcn.component";
import { cn } from "@/dentlab/src/lib/util";

export const PatientExtendedForm: React.FC<{ className?: string }> = ({
	className,
}) => {
	const {
		formData,
		formErrors,
		handleInputChange,
		handleValueChange,
		handleCheckboxChange,
		withinSheet,
	} = usePatientForm();
	const { profile } = useCentralStore((state) => ({
		profile: state.profile,
	}));
	const isPrivacyOn = !!profile?.data_privacy_mode;

	return (
		<div className={cn("flex flex-col gap-1", className)}>
			<AddressGroupShadcn
				formData={formData}
				formErrors={formErrors}
				onChange={handleInputChange}
				onCheckboxChange={handleCheckboxChange}
				exclude={[
					"email",
					"fax",
					"phone_personal",
					"phone_business",
					"phone_mobile",
					"additional_information",
				]}
				onValueChange={(args) =>
					handleValueChange(args.name, args.value)
				}
			/>
			<CustomSelectShadcn
				options={patientFormTexts.options.gender}
				inputLabel="Geschlecht"
				// TODO
				onChange={(value) => handleValueChange("gender", value)}
				value={formData.gender || ""}
			/>
			{/* TODO: DW-334 CustomFormattedTextField und AHV-Nummer Input */}
			{isPrivacyOn ? (
				<Alert
					severity="info"
					sx={{
						marginTop: "10px",
					}}
				>
					AHV-Nummer im Datenschutz-Modus nicht verfügbar
				</Alert>
			) : (
				<CustomTextFieldShadcn
					label="AHV-Nummer"
					name="ahv_number"
					value={formData.ahv_number || ""}
					onChange={handleInputChange}
					validationError={formErrors.ahv_number}
				/>
			)}
		</div>
	);
};
